import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import _DialSessionModal from "routes/dial_sessions/components/DialSessionModal";
import _DeleteDialSessionModal from "routes/dial_sessions/components/DeleteDialSessionModal";
import {
  handleDeleteDialSession,
  invalidateDialSessionTableQuery,
} from "hooks/useDialSessionTable";

const EditDialSessionModal = withRoleCheck(_DialSessionModal, [
  ACL_RELATIONSHIPS.dialSession.edit,
  ACL_RELATIONSHIPS.voicemailForFilters.read,
  ACL_RELATIONSHIPS.emailUrlForms.read,
  ACL_RELATIONSHIPS.campaigns.read,
  ACL_RELATIONSHIPS.tag.read,
  ACL_RELATIONSHIPS.user.read,
  ACL_RELATIONSHIPS.campaignStatuses.read,
]);
const CloneDialSessionModal = withRoleCheck(_DialSessionModal, [
  ACL_RELATIONSHIPS.dialSession.edit,
  ACL_RELATIONSHIPS.voicemailForFilters.read,
  ACL_RELATIONSHIPS.emailUrlForms.read,
  ACL_RELATIONSHIPS.campaigns.read,
  ACL_RELATIONSHIPS.tag.read,
  ACL_RELATIONSHIPS.user.read,
  ACL_RELATIONSHIPS.campaignStatuses.read,
]);
const DeleteDialSessionModal = withRoleCheck(_DeleteDialSessionModal, [
  ACL_RELATIONSHIPS.dialSession.delete,
]);

export function DialSessionTableActions({ original }) {
  return (
    <>
      <CustomDropdown icon="ellipsis horizontal">
        <Dropdown.Menu direction="left">
          <EditDialSessionModal
            dialSessionId={original.id}
            campaignId={original.campaign_id}
            onSuccess={invalidateDialSessionTableQuery}
          />
          <DeleteDialSessionModal
            menuTrigger
            onConfirmDelete={() => handleDeleteDialSession(original.id)}
          />
          <CloneDialSessionModal
            dialSessionId={original.id}
            campaignId={original.campaign_id}
            isClone={true}
            onSuccess={invalidateDialSessionTableQuery}
          />
        </Dropdown.Menu>
      </CustomDropdown>
    </>
  );
}
